module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/mentors__01-be243db376c19781808d5a81da234acf.jpg";